// extracted by mini-css-extract-plugin
export default {"scroll":"dashboard_scroll__nBSPC","filterBtn":"dashboard_filterBtn__qmCXd","tabs":"dashboard_tabs__Gmgt5","filterBtn2":"dashboard_filterBtn2__aEN-e"};